module.exports = __webpack_public_path__ + "static/media/announcments-boomer.abe649dc.svg";